import DOMPurify from "dompurify";
import he from "he";
import { getWindow } from "../../helpers/getWindow";

const ALLOWED_TAGS = ["a", "p", "span", "strong", "em", "b", "i", "u", "br"];

const ALLOWED_ATTR = ["href", "target", "rel", "title", "class", "style"];

let purify;

const secureLinks = (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
};

const getPurify = () => {
  if (purify) return purify;

  const win = getWindow();

  if (win) {
    purify = DOMPurify(win);
  } else if (SERVER) {
    const { JSDOM } = require("jsdom");

    purify = DOMPurify(new JSDOM("").window);
  }

  purify.addHook("afterSanitizeAttributes", secureLinks);

  return purify;
};

const sanitizeMessage = (message) =>
  getPurify().sanitize(he.decode(message), {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: false,
    ALLOW_UNKNOWN_PROTOCOLS: false,
  });

export default sanitizeMessage;
